// K+
import GigyaManager from '../../api/GigyaManager';
import Constants from "../../api/Constants";
import PromoApi from "mbpromo/src/api/PromoApi";

// Vendor
//import moment from 'moment';
import {useI18n} from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';
import moment from "moment";

export default {
    name: "homepage",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data() {
        return {
            promoApi: new PromoApi({
                endpoint: window.API_ENDPOINT + "/api/mulinobianco/2.0/web/promo-engine/",
                promoCode: Constants.API_PROMOCODE
            }),
            images: [
                {
                    "pid": "79578",
                    "imgPath": '2026/79578.jpg',
                    "selected": false
                },
                {
                    "pid": "92506",
                    "imgPath": '2026/92506.jpg',
                    "selected": false
                },
                {
                    "pid": "160379",
                    "imgPath": '2026/160379.jpg',
                    "selected": false
                },
                {
                    "pid": "160380",
                    "imgPath": '2026/160380.jpg',
                    "selected": false
                },
                {
                    "pid": "162005",
                    "imgPath": '2026/162005.jpg',
                    "selected": false
                },
                {
                    "pid": "162014",
                    "imgPath": '2026/162014.jpg',
                    "selected": false
                },
                {
                    "pid": "162018",
                    "imgPath": '2026/162018.jpg',
                    "selected": false
                },
                {
                    "pid": "162085",
                    "imgPath": '2026/162085.jpg',
                    "selected": false
                },
                {
                    "pid": "162100",
                    "imgPath": '2026/162100.jpg',
                    "selected": false
                },
                {
                    "pid": "165201",
                    "imgPath": '2026/165201.jpg',
                    "selected": false
                },
                {
                    "pid": "588698",
                    "imgPath": '2026/588698.jpg',
                    "selected": false
                },
                {
                    "pid": "732603",
                    "imgPath": '2026/732603.jpg',
                    "selected": false
                },
                {
                    "pid": "732617",
                    "imgPath": '2026/732617.jpg',
                    "selected": false
                },
                {
                    "pid": "836221",
                    "imgPath": '2026/836221.jpg',
                    "selected": false
                },
                {
                    "pid": "836226",
                    "imgPath": '2026/836226.jpg',
                    "selected": false
                },
                {
                    "pid": "836230",
                    "imgPath": '2026/836230.jpg',
                    "selected": false
                },
                {
                    "pid": "836233",
                    "imgPath": '2026/836233.jpg',
                    "selected": false
                },
                {
                    "pid": "836235",
                    "imgPath": '2026/836235.jpg',
                    "selected": false
                },
                {
                    "pid": "850251",
                    "imgPath": '2026/850251.jpg',
                    "selected": false
                },
                {
                    "pid": "859587",
                    "imgPath": '2026/859587.jpg',
                    "selected": false
                }
            ],
            chartPreviousYear: [
                {
                    pid: '92506',
                    imgPath: '2025/92506.jpg',
                    selected: false,
                    ranking: '1°'
                },
                {
                    pid: '162005',
                    imgPath: '2025/162005.jpg',
                    selected: false,
                    ranking: '2°'
                },
                {
                    pid: "751344",
                    imgPath: '2025/751344.jpg',
                    selected: false,
                    ranking: '3°'
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 9,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const {t} = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return {t}
    },
    computed: {
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({value, sort: Math.random()}))
                .sort((a, b) => a.sort - b.sort)
                .map(({value}) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal() {
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    mounted() {
        this.checkContestActive();

        GigyaManager.getLoggedUserCached().then((u) => {
            this.userPrivacyProfiling = u.preferences.privacy_profiling.isConsentGranted;
            this.userLogged = true;
            this.promoApi.areaPersonale().then((result) => {
                const vote = result.body.response.data.votes[0];
                if (Object.keys(vote).length > 0) {
                    this.voted = true;
                    this.pidVoted = vote.voted_image;

                    let image = this.images.map(item => item.pid === vote.voted_image);
                    const imageIndex = image.indexOf(true);
                    if (imageIndex || imageIndex === 0) {
                        this.images[imageIndex].selected = true
                    }

                }
            });
        });


        /**
         * Listen vote event
         */
        this.emitter.on("vote", object => {
            let form = {
                basedata: {channelpid: 1},
                customdata: {}
            };

            form.customdata['user_profiling'] = this.userPrivacyProfiling ? 1 : 0;
            form.customdata['content_uri'] = object.pid;

            let objModal = {};

            if (this.voted) {
                const imgNode = this.images.filter(item => item.pid === this.pidVoted);
                // show modal voted
                objModal = {
                    isOpen: true,
                    pathImage: imgNode[0].imgPath,
                    title: this.t('modal.title.voteNotValid'),
                    description: this.t('modal.subtitle.voteNotValid'),
                    voted: true
                };

                // Emit event toggle-modal
                this.emitter.emit("toggle-modal", objModal);
            } else {

                this.promoApi.vota(form).then(() => {
                    const imgNode = this.images.filter(item => item.pid === object.pid);
                    // open modal with success result
                    objModal = {
                        isOpen: true,
                        pathImage: imgNode[0].imgPath,
                        title: this.t('modal.title.thankYou'),
                        description: this.t('modal.subtitle.thankYou'),
                        voted: true,
                        flag: true
                    };
                    this.emitter.emit("toggle-modal", objModal);

                    this.voted = true;
                    this.pidVoted = object.pid;

                    const image = this.images.map(item => item.pid === this.pidVoted);
                    const imageIndex = image.indexOf(true);
                    if (imageIndex || imageIndex === 0) {
                        this.images[imageIndex].selected = true
                    }

                    // add CH to user
                    GigyaManager.addCH(Constants.CH_PROMO);
                }).catch((error) => {

                    // fallback modal error
                    objModal = {
                        isOpen: true,
                        title: 'Ops, qualcosa è andato storto!',
                        description: error.body.status.errors.data.description,
                        voted: false
                    };
                    this.emitter.emit("toggle-modal", objModal);
                });
            }
        });
    },
    methods: {
        // update page and load more images
        loadMore() {
            this.currentPage += 1;
        },

        /**
         * Check if contest is active (true = active, false = inactive)
         * @returns {boolean}
         */
        checkContestActive() {
            this.promoApi.status().then((resp) => {
                console.log(resp)
                let response = resp.body.response.data;
                this.contestActive = moment(response.promo.dates.end.raw, 'YYYY-MM-DD HH:mm:ss').diff(moment()) > 0;
                //this.contestActive = true;
            });
        }
    }
}